
export default "/assets/rss-micro.cc45682e.svg"